import Big from 'big.js'

/**
 * Converts number to max possible decimal precision
 * Everything beoynd precision is rounded
 * Precision can still be smaller then max
 */
export const toMaxPrecision = (number: number, precision: number): number => {
  if (!Number.isFinite(number) || !Number.isFinite(precision) || precision < 0) {
    return number
  }

  const prevPrecision = Big.DP
  Big.DP = precision
  Big.RM = 0
  const string = Big(number).div(1).toString()
  Big.DP = prevPrecision

  return Number(string)
}

export const calculatePrecision = (increment: number, scale: number) => {
  return Number(new Big(increment).times(new Big(10).pow(-scale)))
}

/**
 * Calculates number of decimals from increment and scale values
 * from an InstrumentType
 */
export const calculateDecimals = (increment: number, scale: number) => {
  const precision = calculatePrecision(increment, scale)
  const decimals = parseInt(String(-Math.log10(Number(precision))), 10)
  return decimals >= 0 ? decimals : 0
}
